<template>
    <b-row>
        <b-col cols="9" md="11" align-self="center">
            <datepicker :key="version"
                v-model="content" 
                input-class="form-control"
                :disabled-dates="disabledDates" 
                :highlighted="highlightedDates"
                v-bind="$attrs"
                :required="field.constraints.required"
                :format="formatter">
            </datepicker>

            <b-form-invalid-feedback :id="field.key" style="display:block">
                {{ errors[0] || null }}
            </b-form-invalid-feedback>
        </b-col>

        <b-col cols="3" md="1">
            <b-button variant="danger" @click="content = null"> <b-icon icon="x" /> </b-button>
        </b-col>
    </b-row>
</template>

<script>
import Datepicker from "vuejs-datepicker"
import moment from "moment"
import _ from 'lodash'

export default {
    name: "IdentityField_Date",
    components: {
        Datepicker
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Date | String
        },
        store: {
            type: Object
        },
        context: {
            type: Object,
            default: function() {
                return {}
            }
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            version: 0
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    computed: {
        content: {
            get() {
                return this.value
            },

            set(val) {
                this.check(val)

                if (val == null || val == "") {
                    this.$emit('input', null);
                    return;
                }

                this.$emit('input', moment(val).format("YYYY-MM-DD"));
            }
        },

        disabledDates() {
            let disabledDates = this.field.constraints.date.disabled_dates
            let to = Date.parse(disabledDates.to) || null
            let from = Date.parse(disabledDates.from) || null
            let days = disabledDates.days || []
            let daysOfMonth = disabledDates.days_of_month || []
            let dates = disabledDates.dates || []
            let ranges = disabledDates.ranges || []

            if (this.field.constraints.date.disable_past_dates) {
                let today = new Date()
                let yesterday = new Date()
                yesterday.setDate(today.getDate() - 1);
                
                to = yesterday
            }

            if (this.field.constraints.date.disable_future_dates) {
                from = new Date()
            }

            dates = dates.map(date => {
                return new Date(Date.parse(date))
            })

            ranges = ranges.map(range => {
                return {
                    from: new Date(Date.parse(range.from)),
                    to: new Date(Date.parse(range.to))
                }
            })

            return {
                to: to,
                from: from,
                days: days,
                daysOfMonth: daysOfMonth,
                dates: dates,
                ranges: ranges
            }
        },

        highlightedDates() {
            let disabledDates = this.field.constraints.date.highlighted_dates
            let to = Date.parse(disabledDates.to) || null
            let from = Date.parse(disabledDates.from) || null
            let days = disabledDates.days || []
            let daysOfMonth = disabledDates.days_of_month || []
            let dates = disabledDates.dates || []
            let ranges = disabledDates.ranges || []

            dates = dates.map(date => {
                return new Date(Date.parse(date))
            })

            ranges = ranges.map(range => {
                return {
                    from: new Date(Date.parse(range.from)),
                    to: new Date(Date.parse(range.to))
                }
            })

            return {
                to: to,
                from: from,
                days: days,
                daysOfMonth: daysOfMonth,
                dates: dates,
                ranges: ranges
            }
        },

        constraints() {
            return this.field.constraints;
        }
    },
    methods: {
        check(val) {
            this.errors = []
            
            if (val == "") {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        formatter(date) {
            console.log("formatter", date, this.field.constraints.date.pattern)
            if (this.field.constraints.date.pattern != "") {
                return moment(date).format(this.field.constraints.date.pattern)
            }

            return moment(date).format("YYYY-MM-DD")
        }
    },
    mounted() {
        this.check(this.content)

        this.$emit('input', this.content)
    }
}
</script>